import { UploadOutlined } from "@ant-design/icons";
import { Dropdown, Flex, MenuProps, Spin, Tag } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { StyledLoadingOutlined, StyledUploadOutlinedBig } from "./Styled";

interface ExportDropdownProps {
    isLoading: boolean;
    loadingLabel?: string | number;
    menuItems: MenuProps["items"];
    onMenuClick: MenuProps["onClick"];
}

const ExportDropdown: FC<ExportDropdownProps> = ({
    isLoading,
    loadingLabel,
    menuItems,
    onMenuClick,
}) => {
    const loadingContent = (
        <Tag
            variant="outlined"
            color={"default"}
            style={{
                height: 24,
                display: "flex",
                alignItems: "center",
            }}
        >
            <Flex gap={8}>
                <UploadOutlined />

                <Spin size="small" indicator={<StyledLoadingOutlined spin />} />

                <PrimaryText
                    fontSize={12}
                    fontWeight="600"
                    style={{ lineHeight: 1 }}
                >
                    {loadingLabel}
                </PrimaryText>
            </Flex>
        </Tag>
    );

    const renderTrigger = () => {
        if (isLoading) {
            return (
                <Flex
                    onClick={(e) => e.stopPropagation()}
                    justify="center"
                    align="center"
                >
                    {loadingContent}
                </Flex>
            );
        }

        return <StyledUploadOutlinedBig onClick={(e) => e.stopPropagation()} />;
    };

    if (isLoading) {
        return renderTrigger();
    }

    return (
        <Dropdown
            trigger={["click"]}
            menu={{ items: menuItems, onClick: onMenuClick }}
        >
            {renderTrigger()}
        </Dropdown>
    );
};

export default ExportDropdown;
